export default {
  googleFont: 'https://fonts.googleapis.com/css?family=Poppins:400,900',
  fonts: {
    body: '"Poppins", sans-serif'
  },
  fontWeights: {
    heading: 900,
    bold: 900
  },
  text: {
    heading: {
      fontWeight: 900,
      letterSpacing: '-0.05em'
    }
  },
  styles: {
    blockquote: {
      fontSize: '1.75em',
      textAlign: 'left',
      letterSpacing: '-0.05em'
    }
  }
};